<template>
  <ul class="menu-nav">
    <router-link
      :to="currentRoles.includes(1) ? '/dashboard-master-instituciones' : currentRoles.includes(2) || currentRoles.includes(3) ? '/dashboard-revisor-aprobador' : currentRoles.includes(4) ? '/dashboard-informador' :  currentRoles.includes(5) ? '/dashboard-creador' : '/dashboard'"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">Inicio</span>
        </a>
      </li>
    </router-link>


    <!--Inicio:: link a catalogos -->
    <li v-if="currentRoles.includes(6)"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-close': hasActiveChildren('/profile')
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon far fa-list-alt"></i>
        <span class="menu-text">Catálogos</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/admin/puestos"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Puestos</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/admin/catalogos/periodos"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Periodos medici&oacute;n</span>
              </a>
            </li>
          </router-link>
        </ul>

        <ul class="menu-subnav">
          <router-link
            to="/admin/regiones"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Regiones</span>
              </a>
            </li>
          </router-link>
        </ul>

        <ul class="menu-subnav">
          <router-link
            to="/admin/departamentos"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Departamentos</span>
              </a>
            </li>
          </router-link>
        </ul>

        <ul class="menu-subnav">
          <router-link
            to="/admin/municipios"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Municipalidades</span>
              </a>
            </li>
          </router-link>
        </ul>

        <ul class="menu-subnav">
          <router-link
            to="/admin/catalogos/indices"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">&Iacute;ndices</span>
              </a>
            </li>
          </router-link>
        </ul>
        
        
      <!--Inicio:: datos para listas -->
      <ul class="menu-subnav">
          <router-link
            to="/admin/catalogos/listas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Listas</span>
              </a>
            </li>
          </router-link>
        </ul>
        <!--Fin:: datos para listas -->
        
        <!--Inicio:: datos para Medios de verificación -->
      <ul class="menu-subnav">
          <router-link
            to="/admin/catalogos/mediosverificacion"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Medios de verificación</span>
              </a>
            </li>
          </router-link>
        </ul>
        <!--Fin:: datos para Medios de verificación -->

        

      </div>
    </li>

    <!--Fin:: link a catalogos -->

    <!--Inicio:: link a instituciones -->

    
    <!--Fin:: link a instituciones -->


    <!--Inicio:: seccion a instituciones -->
    <li class="menu-section" v-if="currentRoles.includes(6)">
      <h4 class="menu-text">Gestion de Instituciones</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/instituciones"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon far fa-building"></i>
          <span class="menu-text">Registro Instituciones</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentRoles.includes(6)  || currentRoles.includes(1)"
      to="/admin/institucion/usuarios/registro"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-users"></i>
          <span class="menu-text">Usuarios Institucionales</span>
        </a>
      </li>
    </router-link>
    <!--Fin:: link a usuarios -->

    <!--Inicio:: link a asignacion de aprobadores y revisores -->

    <router-link v-if="currentRoles.includes(6) || currentRoles.includes(1)"
      to="/admin/institucion/usuarios/asignacion-muni-periodo"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-user-plus"></i>
          <span class="menu-text">Asignacion Aprobadores/Revisores</span>
        </a>
      </li>
    </router-link>
    <!--Fin:: link a revisores aprobadores -->





    <!--Inicio:: link a usuarios -->
    <li class="menu-section" v-if="currentRoles.includes(6)">
      <h4 class="menu-text">Gesti&oacute;n de usuarios</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/catalogos/roles"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-user-lock"></i>
          <span class="menu-text">Roles</span>
        </a>
      </li>
    </router-link>


    <router-link v-if="currentRoles.includes(6)"
      to="/admin/usuarios/administradores"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fas fa-user-shield"></i>
          <span class="menu-text">Administradores</span>
        </a>
      </li>
    </router-link>



    

    


  
     <!--Inicio:: link a creadires departamentales -->

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/usuarios/creadores-departamentales"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-users-cog"></i>
          <span class="menu-text">Creadores departamentales</span>
        </a>
      </li>
    </router-link>

    <!-- Fin:: link a creadires departamentales -->

    <!--Inicio:: link a informadores municipales -->

    <li class="menu-section" v-if="currentRoles.includes(5)">
      <h4 class="menu-text">Administrar</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link v-if="currentRoles.includes(5) || currentRoles.includes(6)"
      to="/admin/informadores-municipales"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-user-clock"></i>
          <span class="menu-text">Informadores municipales</span>
        </a>
      </li>
    </router-link>


    <router-link class="d-none"
      to="/admin/informadores-municipales/asingacion-muni"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-users"></i>
          <span class="menu-text">Asignacion Informadores Municipales</span>
        </a>
      </li>
    </router-link>
       
    <!--Fin:: link a revisores aprobadores -->

    <li class="menu-section" v-if="currentRoles.includes(6)">
      <h4 class="menu-text">Gesti&oacute;n de preguntas</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>
    <!--Inicio:: link a modulo preguntas -->
    <li v-if="currentRoles.includes(6)"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-close': hasActiveChildren('/profile')
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon far fa-question-circle"></i>
        <span class="menu-text">Preguntas / Respuestas</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/admin/preguntas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Registro de Preguntas y Respuestas</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
     <!--Fin:: link a modulo preguntas -->

    
    <li class="menu-section" v-if="currentRoles.includes(6)">
      <h4 class="menu-text">Gesti&oacute;n de Boletas</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>
     <router-link v-if="currentRoles.includes(6)"
      to="/admin/boletas/registro"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-copy"></i>
          <span class="menu-text">Registrar Boletas</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/boletas/configuracion"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-tasks"></i>
          <span class="menu-text">Configuración de Boletas</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/boletas/asignacion"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon far fa-list-alt"></i>
          <span class="menu-text">Generar Boletas</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/boletas/apertura-cierre"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-lock-open"></i>
          <span class="menu-text">Apertura Cierre Boletas</span>
        </a>
      </li>
    </router-link>




    <!--Exportación de datos para cálculo -->
    <li class="menu-section" v-if="currentRoles.includes(6)">
      <h4 class="menu-text">Exportaci&oacute;n para C&aacute;lculo</h4>
      <i class="menu-icon fas fa-file-export"></i>
    </li>
     
    <!--Exportación de datos para cálculo -->
    <li v-if="currentRoles.includes(6)"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-close': hasActiveChildren('/admin/calculo')
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon fas fa-file-export"></i>
        <span class="menu-text">Respuestas</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/admin/calculo/diccionario"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Diccionario de respuestas</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/admin/calculo/respuestas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Exportar respuestas</span>
              </a>
            </li>
          </router-link>


          <router-link
            to="/admin/calculo/respuestas-test"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Prueba de exportación</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/admin/calculo/respuestas-aprobadas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Respuestas Aprobadas</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/admin/calculo/respuestas-aprobadas-no-valida-revision"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Respuestas Aprobadas (No valida fase de revisión)</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/admin/calculo/respuestas-ingresadas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">Respuestas Ingresadas</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/admin/calculo/resumen-respuestas-ingresadas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text">Resumen Respuestas Ingresadas</span>
              </a>
            </li>
          </router-link>


        </ul>
      </div>
    </li>



    <!--Importacion e resutlatods -->
    <li class="menu-section" v-if="currentRoles.includes(6)">
      <h4 class="menu-text">Importaci&oacute;n de Resultados</h4>
      <i class="menu-icon fas fa-file-export"></i>
    </li>

    <router-link v-if="currentRoles.includes(6)"
      to="/admin/resultados/campos/registro"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-copy"></i>
          <span class="menu-text">Administraci&oacute;n de campos</span>
        </a>
      </li>
    </router-link>


    <router-link v-if="currentRoles.includes(6)"
      to="/admin/resultados/campos/asignacion"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-copy"></i>
          <span class="menu-text">Asignación&oacute;n de campos</span>
        </a>
      </li>
    </router-link>


    <router-link v-if="currentRoles.includes(6)"
      to="/admin/resultados/campos/importacion"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-copy"></i>
          <span class="menu-text">Importar resultados</span>
        </a>
      </li>
    </router-link>

     <router-link v-if="currentRoles.includes(6)"
      to="/admin/resultados/reportes"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon far fa-chart-bar"></i>
          <span class="menu-text">Reporte de resultados</span>
        </a>
      </li>
    </router-link>
     
    
    


    


    <!--Inicio:: link a compliant 

    <router-link
      to="/admin/compliant"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-file-upload"></i>
          <span class="menu-text">Bandeja Compliant</span>
        </a>
      </li>
    </router-link>
    -Fin:: link a compliant -->


<!--
    <li class="menu-section">
      <h4 class="menu-text">Usuarios</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>
    <router-link
      to="/admin/instituciones/usuarios"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-user-shield"></i>
          <span class="menu-text">Usuarios institucionales</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/admin/municipalidades/usuarios"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-user-friends"></i>
          <span class="menu-text">Usuarios municipales</span>
        </a>
      </li>
    </router-link>





    <li class="menu-section">
      <h4 class="menu-text">Gesti&oacute;n de preguntas</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

 
   

    <li class="menu-section">
      <h4 class="menu-text">Administración de instrumentos</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      to="/admin/indices"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-list-2"></i>
          <span class="menu-text">&Iacute;ndices</span>
        </a>
      </li>
    </router-link>
    

    <router-link
      to="/admin/preguntas/configuracion"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-file-2"></i>
          <span class="menu-text">Configuraci&oacute;n de preguntas</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-close': hasActiveChildren('/profile')
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon far fa-user"></i>
        <span class="menu-text">Registro de preguntas</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/profile/profile-1"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 1</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/profile/profile-2"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 2</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/profile/profile-3"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 3</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/profile/profile-4"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 4</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>

  

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren('/profile')
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon far fa-user"></i>
        <span class="menu-text">Profile</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            to="/profile/profile-1"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 1</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/profile/profile-2"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 2</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/profile/profile-3"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 3</span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/profile/profile-4"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">Profile 4</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>-->
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  },
  computed: {
    ...mapGetters({currentUser:"currentUser"}), //, currentRoles :"currentRoles"

  currentRoles:{
      get(){
         return this.$store.state.auth.roles;
      }
    },

    getFullName() {
      return (
        this.currentUser.nombreUsuario/* +
        " " +
        this.currentUser.nombreUsuario*/
      );
    }
  }
};
</script>
